<template>
  <div class="auth-wrapper">
    <!---Header outside of the card-->
    <div class="auth-container">
      <div class="auth-content-container">
        <div class="auth-header">
          <div class="auth-title">
            <span v-if="step === 2">
              {{ $t("auth.enter_account_info") }}
            </span>
          </div>
          <div class="auth-subtitle">
            {{ $t("auth.create_account") }}: {{ $t("auth.current_step", { step: step, maxSteps: maxSteps + 1 }) }}
          </div>
          <div class="auth-step-indicator">
            <div
              v-for="loopStep in maxSteps + 1"
              :class="step >= loopStep ? 'primary' : ''"
              :key="loopStep"
              class="auth-step-indicator__line"></div>
          </div>
        </div>
      </div>
    </div>
    <!---Header outside of the card END-->

    <div class="auth-container">
      <div class="auth-content-container">
        <v-card class="auth-card">
          <v-stepper class="stepper" elevation="0" v-model="step">
            <v-stepper-items>
              <v-stepper-content style="padding: 0px" step="1"></v-stepper-content>
              <v-stepper-content step="2">
                <v-form ref="form" validate-on="validate" @submit.prevent="submit">
                  <!--
                      Crazy fix for autofill Chrome & Safari
                      https://bugs.chromium.org/p/chromium/issues/detail?id=468153

                      F i x  start
                    -->
                  <input tabindex="-1" style="opacity: 0; position: absolute" />
                  <input tabindex="-1" type="password" style="opacity: 0; position: absolute" />
                  <div style="position: absolute; height: 0px; overflow: hidden">
                    Username <input tabindex="-1" type="text" name="fake_safari_username" /> Password
                    <input tabindex="-1" type="password" name="fake_safari_password" />
                  </div>
                  <phone-input ref="phoneNumber" v-model="form.phoneNumber" @blur="track" />
                  <v-btn color="primary" :loading="loading" @click="submit()" x-large class="auth-btn auth-btn--signup">
                    {{ $t("auth.finish") }}
                  </v-btn>
                </v-form>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
  import store from "@/store";
  import { mdiEyeOutline, mdiEyeOffOutline } from "@mdi/js";
  import themeConfig from "@themeConfig";
  import useAppConfig from "@core/@app-config/useAppConfig";
  import { USER_STATUSES } from "@/constant";
  import { mixpanelWrapper } from "@/@core/libs/mixpanel";
  import PhoneInput from "@/components/custom/PhoneInput";
  import { formErrorMessage } from "@/utility/formErrorMessage";

  export default {
    name: "CompleteRegister",
    components: {
      PhoneInput,
    },
    data() {
      const { appSkinVariant } = useAppConfig();

      return {
        userData: null,
        appSkinVariant,
        appDomain: themeConfig.app.domain,
        icons: {
          mdiEyeOutline: mdiEyeOutline,
          mdiEyeOffOutline: mdiEyeOffOutline,
        },
        appName: themeConfig.app.name,
        appLogo: themeConfig.app.logo,
        step: 1,
        maxSteps: 2,
        form: {
          phoneNumber: "",
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Vilnius",
        },
        loading: false,
      };
    },
    mounted() {
      this.userData = store.getters.getCurrentUser;
      this.step = 2;
      // If user is registered, redirect to dashboard
      if (this.userData.status === USER_STATUSES.REGISTERED) this.$router.push({ name: "dashboard" });
      // since overflow hidden is required for animation, we wait for animation to end and then remove it
      setTimeout(() => {
        document.querySelector(".v-stepper").style.overflow = "visible";
        document.querySelector(".v-stepper__items").style.overflow = "visible";
      }, 400);
    },
    destroyed() {
      document.querySelector(".v-stepper").style.overflow = "hidden";
      document.querySelector(".v-stepper__items").style.overflow = "hidden";
    },
    methods: {
      async submit() {
        if (this.$refs.form.validate() & this.$refs.phoneNumber.validate()) {
          this.loading = true;
          try {
            const response = await this.$admin.dataProvider.customHttpCall("POST", "auth/register/complete", {
              phoneNumber: this.form.phoneNumber,
              timezone: this.form.timezone,
            });

            const { user } = response.data;
            store.dispatch("SET_USER_DATA", user);
            this.$router.push({ name: "billing" });
          } catch (e) {
            this.$admin.toast.error(formErrorMessage(e, this.$t("generic.error")));
            console.error(e);
          } finally {
            this.loading = false;
          }
        }
      },
      track() {
        if (!this.$refs.phoneNumber.validate()) return;
        mixpanelWrapper.track("Account Information Filled", { previous_page: store.getters["getPreviousRoute"] });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import "@core/preset/preset/functions.scss";
  @import "@core/preset/preset/typography/index.scss";

  .auth-wrapper {
    width: 100%;

    &::v-deep {
      .v-stepper__wrapper {
        overflow: visible;
      }
    }
    a {
      text-decoration: unset;
    }
  }
  .auth-container {
    display: flex;
    justify-content: center;
    padding: 4px;
    @media (min-width: 600px) {
      padding: 0;
    }
    .auth-content-container {
      width: 100%;
      @media (min-width: 600px) {
        width: 398px;
      }
    }
  }

  .auth-card {
    padding: 24px;
    border-radius: 6px;
    @media (min-width: 600px) {
      padding: 32px;
    }
    &::v-deep {
      .v-stepper {
        border: none !important;
      }
      .v-stepper__content {
        padding: 0;
      }
    }
    .auth-btn {
      @include text-button-medium();
      background-color: get-color("primary");
      width: 100%;
      color: white;
      padding: 12px 54px;
      border-radius: 4px;

      &:hover {
        background-color: get-color("primary-hover");
      }
      &--signup {
        margin: 24px 0 0;
      }
    }
  }

  .auth-header {
    margin: 24px 0;
    @media (min-width: 600px) {
      margin: 32px 0;
    }
    .auth-title {
      @include heading-4();
      color: get-color("headline");
      margin-bottom: 4px;
      @media (min-width: 600px) {
        @include heading-3();
      }
    }
    .auth-subtitle {
      @include text-body-2();
      color: get-color("subtitle");
      margin-bottom: 16px;
    }
    .auth-step-indicator {
      display: flex;
      gap: 20px;
      &__line {
        height: 5px;
        border-radius: 4px;
        background: get-color("primary-20");
        flex: 1;
      }
    }
  }
</style>
